import React from "react";
import ReactDom from "react-dom";
import FormOrderServices from "./FormOrderServices.jsx";

export function initOrderServicesForm() {
  const div = document.querySelector(".js-order-services-form");
  if (div) {
    if (!window.grecaptcha) {
      const script = document.createElement("script");
      // Site Key owned by Stewart Title
      // As of August 2025, was not configured to work with localhost requests
      // so this will never submit successfully in Storybook.
      script.src =
        "https://www.google.com/recaptcha/api.js?render=6Lc8rwYaAAAAAGsJKqZhD-FjPHtuq1D56kx47AnM";
      document.body.appendChild(script);
    }
    ReactDom.render(
      <FormOrderServices
        locations={div.dataset.props && JSON.parse(div.dataset.props)}
      />,
      div,
    );
  }
}
